import { DateFilter, Filter } from '@/legacy/types';
import { DATEFILTERS } from '@/legacy/constants';

// Only the label is stored; dates are computed from it at query time via resolveDateFilter.
export const createInitialDateFilter = (): DateFilter => ({
	label: DATEFILTERS.TODAY_FILTER_KEY.label,
});

export const formatInitialFiltersForTable = (filters: Filter) => {
	return {
		start_date: filters['start_date'],
		end_date: filters['end_date'],
		dates_logic: filters['dates_logic'],
	};
};
